import { useEffect, useState } from 'react';
import { resolveAssetUrl } from '../api/client';
import { DeckIcon } from './Icons';

interface CardImageProps {
  artUrl: string | undefined | null;
  alt: string;
  /** Ícone mostrado quando não há arte disponível. */
  glyph?: React.ReactNode;
}

/**
 * Imagem de arte com fallback gracioso: se a `artUrl` não resolver ou a imagem
 * falhar ao carregar (404, host indisponível), mostra um marcador no lugar.
 */
export function CardImage({ artUrl, alt, glyph = <DeckIcon /> }: CardImageProps): React.JSX.Element {
  const resolved = resolveAssetUrl(artUrl);
  const [failed, setFailed] = useState(false);

  // Reseta o estado de erro quando a URL muda (ex.: reuso do componente).
  useEffect(() => {
    setFailed(false);
  }, [resolved]);

  if (!resolved || failed) {
    return (
      <div className="art-fallback" aria-hidden>
        <span className="glyph">{glyph}</span>
        <span>{alt}</span>
      </div>
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
